import React from "react";
import ReactDom from "react-dom";

import App from "./App";

import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "./index.css";

ReactDom.render(<App />, document.querySelector("#root"));
